/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './Checkbox.scss';

import classnames from 'classnames';
import noop from 'lodash/noop';
import { bool, func, string } from 'prop-types';
import React from 'react';

const Checkbox = ({
  checked,
  className,
  dataTestId,
  label,
  name,
  onChange,
  partial,
  disabled,
  hasError,
  labelLeft,
  labelRight
}) => {
  const customCheckboxLabelClassname = classnames(
    'custom-checkbox-label',
    className
  );
  const customCheckboxLabelTextClassname = classnames('checkbox-label-text', {
    disabled,
    labelLeft,
    labelRight
  });
  const customCheckboxClassname = classnames('custom-checkbox', {
    checked,
    partial,
    disabled,
    hasError
  });
  const onClick = (event) => {
    event.preventDefault();
    onChange(!checked);
  };

  return (
    <label
      className={customCheckboxLabelClassname}
      data-testid={dataTestId}
      htmlFor={name}
      onClick={disabled === true ? noop : onClick}>
      {label && labelLeft && (
        <span className={customCheckboxLabelTextClassname}>{label}</span>
      )}
      <input
        className="hidden-checkbox"
        checked={checked}
        name={name}
        data-testid={`${dataTestId}-input`}
        id={name}
        onChange={noop}
        type="checkbox"
      />
      <span className={customCheckboxClassname} />
      {label && labelRight && (
        <span className={customCheckboxLabelTextClassname}>{label}</span>
      )}
    </label>
  );
};

Checkbox.propTypes = {
  checked: bool.isRequired,
  className: string.isRequired,
  dataTestId: string,
  name: string.isRequired,
  label: string.isRequired,
  onChange: func.isRequired,
  partial: bool.isRequired,
  disabled: bool.isRequired,
  hasError: bool.isRequired,
  labelLeft: bool.isRequired,
  labelRight: bool.isRequired
};

Checkbox.defaultProps = {
  className: '',
  label: '',
  onChange: noop,
  partial: false,
  disabled: false,
  hasError: false,
  labelLeft: false,
  labelRight: true
};

export default Checkbox;
